import React from 'react'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import type { Group, LineItem } from '../../types/ffe'
import { LineItemCard } from './LineItemCard'

interface Props {
  item: LineItem
  group?: Group
}

const LineItemCardMemo = React.memo(LineItemCard)

export const SortableLineItem: React.FC<Props> = ({ item, group }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging
  } = useSortable({
    id: item.id,
    data: {
      type: 'item'
    }
  })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1
  }

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
      id={`line-item-${item.id}`}
    >
      <LineItemCardMemo item={item} group={group} listeners={listeners} />
    </div>
  )
}
